import { put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { ProductsAttachmentsActions } from "./actionCreators";
import { ProductsAttachmentsStateSelectors } from "./actionSelectors";
import { PRODUCTS_ATTACHMENTS_ACTIONS } from "./actionTypes";
import { ProductsAttachmentsApi } from "./api";
/**
 * Get products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */

function* view(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.view);
}
/**
 * Get products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.list);
}
/**
 * Update products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* update(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.update);
}
/**
 * Create products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* create(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.create, null, null, function* (response) {
    if (!response.error) {
      const {
        result: {
          model
        }
      } = response;
      const {
        result: {
          list: prevAttachments
        }
      } = yield select(ProductsAttachmentsStateSelectors.list);
      const nextAttachments = {
        list: [...prevAttachments, model]
      };
      yield put(ProductsAttachmentsActions.setList(nextAttachments));
    }
  });
}
/**
 * Delete products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteModel(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.delete, null, null, function* (response, searchQuery) {
    const {
      result: {
        success
      } = {}
    } = response;

    if (success) {
      const {
        params: {
          id
        }
      } = searchQuery.getBody();
      const {
        result: {
          list: prevAttachments
        }
      } = yield select(ProductsAttachmentsStateSelectors.list);
      const nextAttachments = {
        list: prevAttachments.filter(attachments => attachments.id !== id)
      };
      yield put(ProductsAttachmentsActions.setList(nextAttachments));
    }
  });
}
/**
 * Sort products attachments.
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* sort(action) {
  yield SagasHelper.action(action, ProductsAttachmentsApi.sort, null, null, function* (response) {
    const nextList = response?.result;

    if (nextList) {
      yield put(ProductsAttachmentsActions.setList(nextList));
    }
  });
}

export default [takeEvery(PRODUCTS_ATTACHMENTS_ACTIONS.CREATE, create), takeEvery(PRODUCTS_ATTACHMENTS_ACTIONS.DELETE, deleteModel), takeLatest(PRODUCTS_ATTACHMENTS_ACTIONS.VIEW, view), takeLatest(PRODUCTS_ATTACHMENTS_ACTIONS.LIST, list), takeLatest(PRODUCTS_ATTACHMENTS_ACTIONS.UPDATE, update), takeLatest(PRODUCTS_ATTACHMENTS_ACTIONS.SORT, sort)];